export class ApiErrorResult {
    constructor(message) {
        this.message = message;
    }
}
